import { Text } from '@bitrise/bitkit';
import { TypeAttribute } from '@trace/types';
import React, { FunctionComponent } from 'react';
import { ATTRIBUTE_NAME_MAP } from '../../constants/Attributes';

interface Props {
  attribute: TypeAttribute;
}

const FiltersGroupLabel: FunctionComponent<Props> = (props) => {
  const { attribute, ...rest } = props;

  return (
    <div {...rest} className="Filters__group-label">
      <Text config="8" textColor="gray-7">
        {ATTRIBUTE_NAME_MAP[attribute]}:
      </Text>
    </div>
  );
};

export default FiltersGroupLabel;
